import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { GlassCard, GlassCardContent, GlassCardHeader, GlassCardTitle } from "@/components/ui/glass-card";
import { ChartContainer, ChartTooltipContent } from "@/components/ui/chart";
import { getAppsByPlatform } from "@/utils/appAnalytics";
import { Device } from "@/types/device";
import { Application } from "@/types/application";

interface AppCountChartProps {
  devices: Device[];
  applications: Application[];
}

const AppCountChart = ({ devices, applications }: AppCountChartProps) => {
  const appCountData = getAppsByPlatform(devices, applications);

  const chartConfig = {
    managed: {
      label: "Managed Apps",
      color: "hsl(220 70% 50%)",
    },
    unmanaged: {
      label: "Unmanaged Apps", 
      color: "hsl(160 60% 45%)",
    },
  };

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-background border rounded-lg shadow-md p-3">
          <p className="font-medium mb-2">{label}</p>
          {payload.map((entry: any, index: number) => (
            <p key={index} className="text-sm" style={{ color: entry.color }}>
              {entry.dataKey}: {entry.value} apps
            </p>
          ))}
          <p className="text-sm text-muted-foreground mt-1 pt-1 border-t">
            Total: {payload[0]?.payload?.total || 0} apps
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <GlassCard variant="strong" hover={false}>
      <GlassCardHeader>
        <GlassCardTitle className="flex items-center gap-2">
          Application Count by Platform
          <span className="text-sm font-normal text-muted-foreground">
            Managed vs unmanaged
          </span>
        </GlassCardTitle>
      </GlassCardHeader>
      <GlassCardContent>
        <ChartContainer config={chartConfig} className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={appCountData}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
              <XAxis 
                dataKey="platform" 
                className="fill-muted-foreground"
              />
              <YAxis className="fill-muted-foreground" />
              <Tooltip content={CustomTooltip} />
              <Legend />
              <Bar 
                dataKey="managed" 
                stackId="a" 
                fill="hsl(220 70% 50%)"
                radius={[0, 0, 0, 0]}
                name="Managed Apps"
              />
              <Bar 
                dataKey="unmanaged" 
                stackId="a" 
                fill="hsl(160 60% 45%)"
                radius={[4, 4, 0, 0]}
                name="Unmanaged Apps"
              />
            </BarChart>
          </ResponsiveContainer>
        </ChartContainer>
      </GlassCardContent>
    </GlassCard>
  );
};

export default AppCountChart;